import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-date-pickers-pro';
import { darken, lighten } from 'polished';
import { useEffect, useRef, useState } from 'react';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Dashboard from './components/dashboard/Dashboard';
import MobileSelection from './components/drawer/MobileSelection';
import Login from './components/Login';
import Nav from './components/nav/Nav';
import PrivateRoute from './utils/PrivateRoute';
import UserProvider from './utils/UserContext';
import MessageProvider from './utils/MessageContext';
import MobileSettings from './components/MobileSettings';

LicenseInfo.setLicenseKey(process.env.REACT_APP_muiX_key);
const resetLocalStorage = () => {
  if (localStorage.getItem("darkMode") === "undefined") {
    localStorage.removeItem("darkMode");
  }
  // if (localStorage.getItem("client") === "undefined") {
  //   localStorage.removeItem("client");
  // }
  if (localStorage.getItem("primary") === "undefined") {
    localStorage.removeItem("primary");
  }
  // if (localStorage.getItem("logo") === "undefined") {
  //   localStorage.removeItem("logo");
  // }
  if (localStorage.getItem("i18nextLng") === "undefined") {
    localStorage.removeItem("i18nextLng");
  }
  // if (localStorage.getItem("url") === "undefined") {
  //   localStorage.removeItem("url");
  // }
};

// const originalFetch = window.fetch;
// window.fetch = async function (input, init) {
//   const url = typeof input === 'string' ? input : input.url;

//   if (url.includes('.well-known/openid-configuration')) {

//     try {
//       const response = await originalFetch(input, init);
//       const clonedResponse = response.clone();
//       const data = await clonedResponse.json();
//       console.log('tokenEndpoint:', data.token_endpoint);
//       if (data.token_endpoint) {
//         sessionStorage.setItem("tokenEndpoint", data.token_endpoint);
//       }
//       return response;
//     } catch (error) {
//       console.error('Error in OpenID Configuration request:', error);
//       throw error;
//     }
//   }

//   const tokenEndpoint = sessionStorage.getItem("tokenEndpoint");
//   if (tokenEndpoint && url === tokenEndpoint) {
//     try {
//       const response = await originalFetch(input, init);
//       if (response.status === 200) {
//         window.location.href = "/dashboard";
//       };
//       return response;
//     } catch (error) {
//       console.error('Error in token endpoint request:', error);
//       throw error;
//     }
//   }

//   return originalFetch(input, init);
// };

function App() {
  resetLocalStorage();

  const [darkMode, setDarkMode] = useState(false);

  const load = useRef(true);
  const displayContent = useRef(false);

  const client = {
    //sets the external provider client id if given, else sets the connecor id or a fallaback value
    client_id: localStorage.getItem("externalClientId") && localStorage.getItem("externalClientId") !== null && localStorage.getItem("externalClientId") !== undefined ? localStorage.getItem("externalClientId") : localStorage.getItem("client") || process.env.REACT_APP_generic_client_client_id,
    //if no external provider is present assume keycloak
    authority: localStorage.getItem("authority") && localStorage.getItem("authority") !== null && localStorage.getItem("authority") !== undefined ? localStorage.getItem("authority") : process.env.REACT_APP_generic_client_authority,
    redirect_uri: process.env.REACT_APP_generic_client_redirect_uri,
    scope: localStorage.getItem("externalScope") && localStorage.getItem("externalScope") !== null && localStorage.getItem("externalScope") !== undefined ? localStorage.getItem("externalScope") : 'openid email profile',
    automaticSilentRenew: true,
    onSigninCallback: async (user) => {
      if (user) {
        window.history.replaceState({}, document.title, window.location.pathname);
      };
    }
  };

  // "#E30613" (vig color)
  const primary = localStorage.getItem("primary") || "#0075FF";

  useEffect(() => {
    if (localStorage.getItem("darkMode") === "true") {
      setDarkMode(true);
    } else {
      setDarkMode(false);
    }
    //eslint-disable-next-line
  }, [])

  // var i;
  // console.log("local storage");
  // for (i = 0; i < localStorage.length; i++) {
  //   console.log(localStorage.key(i) + "=[" + localStorage.getItem(localStorage.key(i)) + "]");
  // }

  const hexToRgb = hex => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      primary: {
        main: primary
      },
      secondary: {
        main: darkMode ? darken(0.2, primary) : primary === "#0075FF" ? "#bdddf2" : lighten(0.42, primary)
      },
      success: {
        main: "#00B954"
      },
      info: {
        main: "#DCDCDC"
      },
      favorite: {
        main: "#979797"
      },
      base: {
        main: "#0075FF",
        secondary: "#EEF0F3"
      },
      background: {
        secondary: darkMode ? primary === "#0075FF" ? "#081d2b" : darken(0.45, primary) : `rgba(${hexToRgb(primary).r}, ${hexToRgb(primary).g}, ${hexToRgb(primary).b}, 0.10)`
      },
      tonalOffset: .2
    },
    typography: {
      fontFamily: 'Plus Jakarta Sans'
    }
  })


  //suppress yellow warnings
  console.disableYellowBox = true;

  const Redirect = () => {
    return <Navigate replace to="/login" />;
  };

  return (
    <AuthProvider {...client}>
      <BrowserRouter>
        <UserProvider>
          <MessageProvider>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <Nav setDarkMode={setDarkMode} />
              <Routes>
                <Route exact path="/login" element={<Login />} />
                <Route exact path="/dashboard" element={
                  <PrivateRoute redirect={"/dashboard"} >
                    <Dashboard load={load} displayContent={displayContent} />
                  </PrivateRoute>
                } />
                <Route exact path="/select" element={
                  <PrivateRoute redirect={"/select"} >
                    <MobileSelection />
                  </PrivateRoute>
                } />
                <Route exact path="/settings" element={
                  <PrivateRoute redirect={"/settings"} >
                    <MobileSettings setDarkMode={setDarkMode} />
                  </PrivateRoute>
                } />
                <Route exact path="*" element={<Redirect />} />
              </Routes>
            </ThemeProvider>
          </MessageProvider>
        </UserProvider>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App;